import { TableRow } from '@shared/UI';
import { IReserveComputationDate } from './ReserveComputationTableProvider';

interface IOptions {
    onReserveComputationClick: (date: IReserveComputationDate) => void;
}

export function getReserveComputationTableRows(options: IOptions): TableRow {
    const { onReserveComputationClick } = options;
    return { onClick: (row) => () => onReserveComputationClick(row) };
}
